import { DialogContent } from '@mui/material';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import {
  formatBalanceUi,
  removeMinusFromBalance,
} from '@utils/balance-helpers';
import { TransactionStatus } from '@widgets/tables/cells/transactions/TransactionStatusCell';
import { ListData, Avatar, CountryFlag } from '@shared/ui/parts';
import {
  getConversionRate,
  getOperationFee,
} from '@widgets/tables/cells/transactions/TransactionChargedCell';
import { TransactionCreatedAt } from '@widgets/tables/cells/transactions/TransactionDetailsCell';
import { RenderItemBank } from '@shared/ui/forms/select-render';
import { binsLogo, currencySymbols } from '@utils/static';
import { icons } from '@shared/static/icons';
import { useViewCardDialog } from '@utils/dialogs-hooks';

export default function TransactionDetailsDialog({ data, close }) {
  const { tariff } = useSelector((state) => state.tariff);
  const { t } = useTranslation();
  const { openViewCardDialog } = useViewCardDialog();

  console.log(data);

  const listData = [
    {
      label: t('charged'),
      icon: 'charged',
      value: `${removeMinusFromBalance(formatBalanceUi(data?.amount, data?.currency))}`,
    },
    {
      label: t('conversion_rate'),
      value: `${getConversionRate(data)}`,
    },
    {
      label: t('operation_fee'),
      value: `${getOperationFee(data, tariff)}`,
    },
    {
      label: t('date_time'),
      component: <TransactionCreatedAt row={data} />,
    },
    {
      label: t('member'),
      value: data?.user_name,
    },
    {
      label: t('team'),
      component: (
        <div className="memberTeamCell__team">
          <Avatar team={data?.user_group} />
          {data?.user_group?.name}
        </div>
      ),
    },
  ];

  return (
    <>
      <DialogContent>
        <p
          className="title-h1r"
          dangerouslySetInnerHTML={{
            __html: formatBalanceUi(
              removeMinusFromBalance(data?.original_amount),
              data?.currency_original,
              null,
              true,
            ),
          }}
        />
        <TransactionStatus row={data} />
        <ListData listData={listData} />
        <div onClick={() => openViewCardDialog(data?.card_id)}>
          <RenderItemBank
            arrowIcon
            item={{
              bank_id: data?.bank?.id,
              bank_public_name: data?.bank?.public_name,
              card_type: data?.card_type,
              currency: data?.currency,
              bin: data?.card_number,
            }}
          />
        </div>
      </DialogContent>
    </>
  );
}
